var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconInfo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Webhooks-2---option-1",
    transform: "translate(-403.000000, -230.000000)",
    fill: "#6E6E6E"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Info",
    transform: "translate(400.000000, 227.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,3.33333333 C6.33333333,3.33333333 3.33333333,6.33333333 3.33333333,10 C3.33333333,13.6666667 6.33333333,16.6666667 10,16.6666667 C13.6666667,16.6666667 16.6666667,13.6666667 16.6666667,10 C16.6666667,6.33333333 13.6666667,3.33333333 10,3.33333333 L10,3.33333333 Z M10.8333333,13.75 C10.8333333,14 10.6666667,14.1666667 10.4166667,14.1666667 L9.58333333,14.1666667 C9.33333333,14.1666667 9.16666667,14 9.16666667,13.75 L9.16666667,8.75 C9.16666667,8.5 9.33333333,8.33333333 9.58333333,8.33333333 L10.4166667,8.33333333 C10.6666667,8.33333333 10.8333333,8.5 10.8333333,8.75 L10.8333333,13.75 L10.8333333,13.75 Z M10.8333333,7.08333333 C10.8333333,7.33333333 10.6666667,7.5 10.4166667,7.5 L9.58333333,7.5 C9.33333333,7.5 9.16666667,7.33333333 9.16666667,7.08333333 L9.16666667,6.25 C9.16666667,6 9.33333333,5.83333333 9.58333333,5.83333333 L10.4166667,5.83333333 C10.6666667,5.83333333 10.8333333,6 10.8333333,6.25 L10.8333333,7.08333333 L10.8333333,7.08333333 Z",
    id: "Info_2_x2C__About_2"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconInfo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Icon-Info.097dff7ef0591a309c494191935596e1.svg";